<!-- <div style="background-color: salmon;"> -->

<scully-content></scully-content>

<div class="ultimateguide-content" *ngIf="false">
  <img
    class="img-no-detail"
    src="https://flowaccountcdn.com/new_landing/image/desktop/SpecialService/New_Financial_banner_Desktop.jpg"
    width="100%"
    alt="FlowAccount Ultimate Guide"
  />

  <h2 class="head-content">ทำบัญชีเอง ดีไหม</h2>
  <div class="head-detail"
    >สำหรับเจ้าของธุรกิจคนเดียว อาจจะเริ่มต้นจากการทำบัญชีรายรับ-รายจ่ายง่ายๆ แต่เมื่อธุรกิจเติบโตขึ้น
    โดยเฉพาะกิจการที่จดทะเบียนภาษีมูลค่าเพิ่ม หรือทำธุรกิจในรูปแบบนิติบุคคล
    เจ้าของธุรกิจก็มีหน้าที่ต้องจัดทำรายงานเกี่ยวกับภาษีต่างๆ รวมถึงยื่นแบบภาษีแต่ละประเภท
  </div>

  <div class="qeout"
    >"การทำบัญชีเองจะทำให้เราทราบถึงรายรับ-รายจ่าย กำไร-ขาดทุน
    หรือภาพรวมสภาพคล่องของบริษัทที่จะทำให้วางแผนบริหารธุรกิจได้ดีขึ้น ซึ่งโปรแกรมบัญชีออนไลน์ FlowAccount
    ช่วยให้คุณสามารถทำบัญชีเบื้องต้นเองได้อย่างไม่ยุ่งยาก"</div
  >

  <h2 class="head-content">โปรแกรมบัญชีออนไลน์ ช่วยคุณได้อย่างไร</h2>
  <h3 class="subhead-content">ตอบโจทย์การทำงานเพื่อเจ้าของธุรกิจ</h3>
  <div class="head-detail"
    >โปรแกรมบัญชี เปรียบได้กับผู้ช่วยชั้นเลิศในการทำงาน ทั้งการบันทึกบัญชี เก็บรวบรวมเอกสาร สร้างรายงานที่สำคัญ
    รวมไปถึงการกำหนดการควบคุมภายในที่ดี</div
  >
  <div class="head-detail"
    >ดังนั้นเจ้าของธุรกิจ ควรจะให้เวลาในการเลือกโปรแกรมบัญชีสักนิด
    เพราะมันหมายถึงเครื่องการันตีว่าเราจะเริ่มต้นทำงานบัญชีได้อย่างง่ายดายและสะดวกสบายมากที่สุด</div
  >
  <div class="head-detail"
    ><span
      >โปรแกรมบัญชีออนไลน์ FlowAccount ให้คุณเริ่มต้นใช้งานได้ฟรี ไม่ต้องใช้ทุนมากในการทำธุรกิจ
      โดยจากนี้จะขออธิบายรายละเอียดของ<a href="" target="_blank">เอกสารต่างๆ ที่ผู้ประกอบการควรรู้</a>
      ผ่านฟังก์ชั่นการทำงานต่างๆ ของ FlowAccount
      พร้อมวิธีเรียกดูข้อมูลรายงานทางบัญชีเพื่อส่งแบบให้ทางกรมสรรพากรด้วยตัวเอง</span
    ></div
  >

  <h3 class="subhead-content">ตอบโจทย์การทำงานของนักบัญชี</h3>
  <div class="subhead-list">
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >ไม่ต้องคีย์เอกสารบัญชีซ้ำๆ ในโปรแกรมบัญชีออนไลน์ เพราะเมื่อผู้ประกอบการสร้างเอกสารบิลซื้อ บิลขาย
        ระบบจะบันทึกบัญชีอัตโนมัติ ดังนั้นภาระงานของนักบัญชีในการคีย์เอกสารจะลดลงอย่างเห็นได้ชัด นักบัญชีมีเวลามากขึ้น
        สามารถขยับบทบาทมาเป็นที่ปรึกษาให้กับเจ้าของธุรกิจได้</span
      >
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >เมื่อลูกค้า หรือเจ้าของธุรกิจสร้างเอกสาร ผู้ทำบัญชีก็จะเห็นข้อมูลนั้นทันที และเข้ามาตรวจสอบข้อมูลได้เลย
        ไม่ต้องรอให้ถึงสิ้นเดือนหรือสิ้นปีกว่าเอกสารจะมาส่งแล้วจึงจะทำงานได้</span
      >
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i><span>ไม่ต้องเสียเวลาในการติดตั้งโปรแกรม อัปเกรด หรือแบ็กอัพข้อมูล</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >สามารถทำงานจากที่ไหนก็ได้ด้วยโน้ตบุ๊ก แท็บเล็ต หรือมือถือ จึงไม่ต้องเสียเวลาเดินทางเข้าออฟฟิศ
        หรือต้องนั่งอยู่ในออฟฟิศตลอดเวลา</span
      >
    </div>
    <div class="column-list last">
      <i class="fas fa-circle"></i
      ><span
        >FlowAccount มีบริการหลังการขาย และเจ้าหน้าที่คอยให้คำแนะนำการใช้งานและทำบัญชีแก่เจ้าของธุรกิจ
        จึงช่วยประหยัดเวลาการทำงานของนักบัญชีได้มาก</span
      >
    </div>
  </div>

  <h3 class="subhead-content">ฟังก์ชั่นของ FlowAccount ที่ช่วยให้ธุรกิจของคุณราบรื่น</h3>
  <div class="subhead-list">
    <div class="column-list">
      <i class="fas fa-circle"></i><span>เมนูแสดงภาพรวมของธุรกิจ (dashboard) ช่วยให้คุณรู้ภาพรวมของกิจการได้ทันที</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >สร้างเอกสารทางธุรกิจ ได้แก่ ใบเสนอราคา ใบวางบิล ใบแจ้งหนี้ ใบเสร็จรับเงิน ใบกำกับภาษีแบบเต็มรูป
        ใบกำกับภาษีอย่างย่อ ใบสั่งซื้อ ใบรับสินค้า ใบลดหนี้ ใบเพิ่มหนี้ และเมนูขายเงินสด</span
      >
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i><span>จัดหมวดหมู่ค่าใช้จ่าย และ บันทึกค่าเสื่อมราคาได้</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span>เชื่อมต่อกับระบบจัดการสินค้าคงเหลือ ช่วยบริหารสินทรัพย์ จัดการสต็อกสินค้าได้</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i><span>ฟังก์ชั่นบริหารภาษีมูลค่าเพิ่ม รองรับการสร้างรายงานทางภาษี</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >มีสมุดบัญชี 5 เล่มครบถ้วน ได้แก่ สมุดรายวันซื้อ สมุดรายวันขาย สมุดรายวันจ่าย สมุดรายวันรับ และ
        สมุดรายวันทั่วไป</span
      >
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i><span>สามารถจัดการรายละเอียดลูกค้าและซัพพลายเออร์ได้</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i><span>มีรายงานบัญชีที่จำเป็น เช่น ลูกหนี้การค้า เจ้าหนี้การค้า</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span>สร้างงบการเงินได้อย่างอัตโนมัติทั้ง งบทดลอง งบกำไรขาดทุน งบแสดงฐานะทางการเงินของกิจการ</span>
    </div>
    <div class="column-list"> <i class="fas fa-circle"></i><span>พิ่มจำนวนผู้ใช้งานได้</span> </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >FlowPayroll โปรแกรมเงินเดือนออนไลน์ ช่วยคำนวณภาษี หัก ณ ที่จ่าย เงินสมทบประกันสังคม
        เชื่อมโยงข้อมูลเงินเดือนมาลงบัญชีอัตโนมัติในโปรแกรมบัญชี FlowAccount ทำให้ประหยัดเวลาในการสรุปค่าใช้จ่าย
        ทำภาษีรายเดือน และสรุปกำไรขาดทุน พร้อมเชื่อมต่อระบบ K-Cash Connect Plus จากธนาคารกสิกรไทย
        ให้คุณสั่งจ่ายเงินเดือนได้ทันที</span
      >
    </div>
    <div class="column-list last">
      <i class="fas fa-circle"></i
      ><span
        >AutoKey ระบบสแกนบิลและใบเสร็จ ที่จะทำให้การบันทึกค่าใช้จ่ายเป็นเรื่องง่าย เจ้าของธุรกิจก็ทำบัญชีเองได้
        เพียงใช้กล้องมือถือถ่ายรูปบิลและอัพโหลดภาพ หมดกังวลเรื่องการพิมพ์ผิด ด้วยเทคโนโลยี OCR
        ที่ช่วยแปลงภาพเป็นข้อมูลบัญชี ทำได้ทุกที่ผ่านเว็บไซต์และแอปพลิเคชั่นมือถือ เชื่อมรายการค่าใช้จ่ายพร้อมเก็บไฟล์ใน
        FlowAccount</span
      >
    </div>
  </div>
  <div style="color: red">list-with-img no des</div>
  <div class="list-with-img">1. texttttttttttt</div>
  <img
    class="img-no-detail"
    src="https://flowaccountcdn.com/new_landing/image/desktop/SpecialService/New_Financial_banner_Desktop.jpg"
    width="100%"
    alt="FlowAccount Ultimate Guide"
  />

  <div style="color: red">img double</div>
  <div class="double-img">
    <div class="show left">
      <img
        class="img-no-detail"
        src="https://flowaccountcdn.com/new_landing/image/desktop/SpecialService/New_Financial_banner_Desktop.jpg"
        width="100%"
        alt="FlowAccount Ultimate Guide"
      />
    </div>
    <div class="show right">
      <img
        class="img-no-detail"
        src="https://flowaccountcdn.com/new_landing/image/desktop/SpecialService/New_Financial_banner_Desktop.jpg"
        width="100%"
        alt="FlowAccount Ultimate Guide"
      />
    </div>
  </div>

  <div style="color: red">list-with-img</div>
  <div class="list-with-img">1. texttttttttttt</div>
  <img
    class="img-with-detail"
    src="https://flowaccountcdn.com/new_landing/image/desktop/SpecialService/New_Financial_banner_Desktop.jpg"
    width="100%"
    alt="FlowAccount Ultimate Guide"
  />
  <div class="detail-under-img">ตัวอย่าง ฟอร์มใบเสนอราคา ที่ออกโดย โปรแกรมบัญชี FlowAccount</div>

  <div style="color: red">subhead-list number</div>
  <div>1. testtt</div>
  <div class="subhead-list number">
    <div class="column-list">
      <i class="fas fa-circle"></i><span>เมนูแสดงภาพรวมของธุรกิจ (dashboard) ช่วยให้คุณรู้ภาพรวมของกิจการได้ทันที</span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i
      ><span
        >สร้างเอกสารทางธุรกิจ ได้แก่ ใบเสนอราคา ใบวางบิล ใบแจ้งหนี้ ใบเสร็จรับเงิน ใบกำกับภาษีแบบเต็มรูป
        ใบกำกับภาษีอย่างย่อ ใบสั่งซื้อ ใบรับสินค้า ใบลดหนี้ ใบเพิ่มหนี้ และเมนูขายเงินสด</span
      >
    </div>
  </div>
  <div>2. testtt</div>

  <div style="color: red">subhead-list number in number</div>
  <div>1. testtt</div>
  <div class="subhead-list number">
    <div class="column-list">1.1 hello</div>
    <div class="column-list">1.2 hello</div>
  </div>

  <div style="color: red">video</div>
  <div class="view-video">
    <div class="vdo-content embed-responsive embed-responsive-16by9">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/2GRP1rkE4O0"
        frameborder="0"
        allowfullscreen=""
      ></iframe>
    </div>
  </div>

  <div style="color: red">cta</div>
  <div class="cta-page">
    <div class="cta-img"><img src="https://flowaccountcdn.com/assets/images/FlowAccount_Team.jpg" /></div>
    <div class="cta-detail">
      <div>โปรแกรมบัญชี FlowAccount ช่วยคุณ <br />ออกใบเสนอราคาได้นะ!</div>
      <a href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register" class="flowbtn app-btn"
        >ทดลองใช้งาน คลิกเลย!</a
      >
    </div>
  </div>

  <div class="subhead-list">
    <div
      ><span class="text-bold">1. รายได้และค่าใช้จ่ายตามเอกสาร (Acrual Basis)</span>
      เป็นมุมมองที่ดูรายได้-รายจ่ายจากวันที่มีการเปิดเอกสารไป</div
    >
    <div
      ><span class="text-bold">2. รายได้และค่าใช้จ่ายตามการรับ-จ่าย (Cash Basis)</span
      >เป็นมุมมองที่ดูรายได้-รายจ่ายจากวันที่ได้รับเงินและจ่ายเงินจริง</div
    >
  </div>

  <div class="subhead-list">
    <div class="column-list">
      <i class="fas fa-circle"></i>
      <span>
        <span class="text-bold">หากต้องการดู “กำไรขาดทุนเบื้องต้น” ให้เลือกมุมมอง รายได้และค่าใช้จ่ายตามเอกสาร</span>
        ส่วนนี้ก็คือการสรุปข้อมูลรายได้และค่าใช้จ่ายทั้งหมดจากเอกสารทั้งหมดที่สร้างขึ้นในระบบ มาสรุปให้ในแต่ละเดือน
        เพื่อเปรียบเทียบได้อย่างง่ายๆ ว่าสุดท้ายแล้วในเดือนนั้นๆ ธุรกิจมีรายได้มากกว่าค่าใช้จ่าย
        หรือค่าใช้จ่ายมากกว่ารายได้ ถ้ารายได้มากกว่าค่าใช้จ่ายก็คือน่าจะกำไร ถ้าค่าใช้จ่ายมากกว่ารายได้ก็คือน่าจะขาดทุน
        ดังนั้น ส่วนของกำไรขาดทุนเบื้องต้น จะใช้ยอดก่อนภาษี
      </span>
    </div>
    <div class="column-list">
      <i class="fas fa-circle"></i>
      <span>
        <span class="text-bold">หากต้องการดู “เงินสดเข้าออก” ให้เลือกมุมมอง รายได้และค่าใช้จ่ายตามการรับ-จ่าย</span>
        ส่วนนี้ขึ้นอยู่กับการรับเงินหรือจ่ายเงินจากเอกสารในระบบ จึงตอบโจทย์ในเรื่องของดูเงินเข้า เทียบกับเงินออก
        ซึ่งจะดูจากเงินเข้าออกจริง ดังนั้นยอดตรงนี้จะรวมภาษีเข้าไปด้วย เพราะดูยอดจ่าย และยอดรับ สุทธิจากภาษีหัก ณ
        ที่จ่าย
      </span>
    </div>
  </div>

  <div class="subhead-list">
    <div class="text-bold">ตัวหนาๆๆๆๆๆ</div>
  </div>

  <div class="list-with-img text-bold">วิธีที่ 1: สร้างใบวางบิลต่อจากใบเสนอราคาที่เคยสร้างไว้</div>

  <blockquote style="max-width: 500px; margin: 0 auto"
    >“การทำบัญชีเองจะทำให้เราทราบถึงรายรับ-รายจ่าย กำไร-ขาดทุน
    หรือภาพรวมสภาพคล่องของบริษัทที่จะทำให้วางแผนบริหารธุรกิจได้ดีขึ้น ซึ่งโปรแกรมบัญชีออนไลน์ FlowAccount
    ช่วยให้คุณสามารถทำบัญชีเบื้องต้นเองได้อย่างไม่ยุ่งยาก”
  </blockquote>

  <!-- <div class="allCta">
    <div class="allCta-text">ช่วยให้ก้าวแรกของธุรกิจคุณไม่สะดุด ด้วย FlowAccount โปรแกรมบัญชี ออนไลน์ สำหรับนักธุรกิจยุคใหม่ ใช้งานง่าย
    ทำได้ด้วยตัวเอง</div>
      <a href="https://auth.flowaccount.com/Account/Register" class="flowbtn app-btn">สมัครใช้งานฟรี</a>
  </div> -->
</div>

<!-- <app-cta-desktop></app-cta-desktop> -->

<!-- <downloadpdf-desktop-element></downloadpdf-desktop-element> -->

<!-- <downloadpdf-desktop-element></downloadpdf-desktop-element> -->

<!-- <app-downloadpdf-desktopp></app-downloadpdf-desktop> -->

<!-- </div> -->
